import { AlarmRow } from "@src/cloud-connect/alarms/entities/alarm-row";

const normalizeSearchTerms = (searchTerms: string[]): string[] =>
  searchTerms.map((term) => term.toLowerCase()).filter(Boolean);

export const findSearchedAlarmRows = (
  alarmRows: AlarmRow[],
  searchTerms: string[],
): AlarmRow[] => {
  const normalized = normalizeSearchTerms(searchTerms);
  if (!normalized.length) return [];

  return alarmRows.filter((row) => {
    const node = row.getAlarm().getOurNode();
    const nodeName = node.name?.toLowerCase() ?? "";
    const nodeId = node.id?.toLowerCase() ?? "";

    return normalized.every(
      (term) => nodeName.includes(term) || nodeId.includes(term),
    );
  });
};
